<!-- 音像 -->

<template>
  <div class="press-2">
    <div v-if="wSat == 0" v-loading="true" class="dvsWait"></div>
    <div v-if="wSat == 2" class="succedTips">
      材料已提交至省局，可从
      <router-link to="pgress_step"><a>核验进度</a> </router-link> 菜单查看审核进度。
    </div>
    <div v-if="wSat == 1">
      <MainTabs
        v-if="frashCode"
        @go-frash="frashHandle"
        :pressType="2"
        :pressDat="resDat"
        @valChangeSearch="valChangeSearch" />
    </div>
  </div>
</template>

<script>
import MainTabs from "@/views/pressRole/pressComps/CommonTab";
import { getPressList } from "@/api/pressRole/pressRole";
export default {
  components: {
    MainTabs,
  },
  data() {
    return {
      frashCode: true,
      opMsg: "",
      postId: "",
      wSat: 0,
      resDat: [{}],
    };
  },
  methods: {
    valChangeSearch: function (val) {
      let vm = this;
      getPressList({
        year: val,
        type: 2,
      }).then((response) => {
        console.log("getPressList: ", response, vm.resDat);
        // 显示历史信息，提交控制在里边做
        vm.wSat = 1;
        vm.resDat.splice(0, 1, response);
        console.log("resDat: ", vm.resDat);
      });
    },
    frashHandle: function () {
      let vm = this;
      getPressList({
        type: 2,
      }).then((response) => {
        vm.resDat.splice(0, 1, response);
        vm.frashCode = false;
        vm.$nextTick(() => {
          vm.frashCode = true;
        });
      });
    },
  },
  created: function () {
    let vm = this;
    let cacheYear = sessionStorage.getItem("selYear");

    getPressList({
      type: 2,
    }).then((response) => {
      console.log("getPressList: ", response, vm.resDat);
      if (response.pubStatus == 0) {
        vm.wSat = 1;
        vm.resDat.splice(0, 1, response);
        console.log("resDat: ", vm.resDat);
      } else if (response.pubStatus == 1) {
        vm.wSat = 2;
      }
    });
  },
};
</script>

<style lang="scss" type="text/css">
.press-2 {
  padding: 0px 12px;

  .succedTips {
    font-size: 14px;
    color: #666666;
    padding: 20px;

    a {
      color: #409eff;
    }
  }

  .dvsWait {
    text-align: center;
    line-height: 240px;
    font-size: 24px;
    color: #999999;
  }
}
</style>



// WEBPACK FOOTER //
// electPress.vue?466bed1b